import React from "react";
import { FormField } from "./";
import { FullNameSuffixData } from "../../forms/generic";
import { Utility } from "../../utils";
import { ValidatedFormFieldBase, ValidatedInput } from "../validation";

interface OwnProps {
}

export class FullNameSuffixField extends ValidatedFormFieldBase<OwnProps, {}> {

    public render() {
        const label = this.getLabel(this.props.label);
        const value: FullNameSuffixData | undefined = this.getValue() as FullNameSuffixData;

        return <FormField {...this.props} errors={this.getErrors()} label={label} name={this.props.name} required={this.isRequired(this.props.required)}>
            <div className="field-single-line fields-name-long">
                <p className="field-name-first">
                    <ValidatedInput
                        formComponent={this.props.formComponent}
                        type="text"
                        id={Utility.toHtmlIdString(this.props.name + ".first")}
                        name={this.props.name + ".first"}
                        css="txt"
                        placeholder="First"
                        value={value ? (value.first || "") : ""}
                    />
                </p>
                <p className="field-name-middle">
                    <ValidatedInput
                        formComponent={this.props.formComponent}
                        type="text"
                        id={Utility.toHtmlIdString(this.props.name + ".middle")}
                        name={this.props.name + ".middle"}
                        css="txt"
                        placeholder="Middle"
                        value={value ? (value.middle || "") : ""}
                    />
                </p>
                <p className="field-name-last">
                    <ValidatedInput
                        formComponent={this.props.formComponent}
                        type="text"
                        id={Utility.toHtmlIdString(this.props.name + ".last")}
                        name={this.props.name + ".last"}
                        css="txt"
                        placeholder="Last"
                        value={value ? (value.last || "") : ""}
                    />
                </p>
                <p className="field-name-suffix">
                    <ValidatedInput
                        formComponent={this.props.formComponent}
                        type="text"
                        id={Utility.toHtmlIdString(this.props.name + ".suffix")}
                        name={this.props.name + ".suffix"}
                        css="txt"
                        placeholder="Jr, III, etc."
                        value={value ? (value.suffix || "") : ""}
                    />
                </p>
            </div>
        </FormField>;
    }
}



// WEBPACK FOOTER //
// ./src/components/editors/FullNameSuffixField.tsx